import React from "react";

import DownloadDialogue from "./DownloadDialogue";

import { makeStyles } from "@material-ui/core/styles";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import CardActions from "@material-ui/core/CardActions";
import Button from "@material-ui/core/Button";
import CardHeader from "@material-ui/core/CardHeader";
import Grid from "@material-ui/core/Grid";
import Paper from "@material-ui/core/Paper";

const useStyles = makeStyles((theme) => ({
  paper: {
    height: "100%",
    backgroundSize: "contain",
    backgroundRepeat: "repeat",
    backgroundPosition: "center",
  },
  root: {
    display: "flex",
    minHeight: 230,
    maxHeight: 400,
  },
  details: {
    width: "100%",
    display: "flex",
    flexDirection: "column",
    position: "relative",
    paddingBottom: 45,
  },
  content: {
    paddingTop: 0,
    overflowY: "auto",
  },
  cover: {
    minWidth: 150,
  },
  controls: {
    display: "flex",
    alignItems: "center",
    paddingLeft: theme.spacing(1),
    paddingBottom: theme.spacing(1),
  },
  actions: {
    position: "absolute",
    bottom: 0,
    height: 45,
  },
  grid: {
    marginBottom: 8,
  },
}));

export default function BookOverview(props) {
  const classes = useStyles();

  const [downloadDialogueOpen, setDownloadDialogueOpen] = React.useState(false);

  const openDownloadLinksDialogue = () => {
    setDownloadDialogueOpen(true);
  };

  const closeDownloadLinksDialogue = () => {
    setDownloadDialogueOpen(false);
  };

  const renderPublisher = (publisher) => {
    if (publisher) {
      return (
        <Typography variant="body2" color="textSecondary" component="p">
          {`Publisher: ${publisher}`}
        </Typography>
      );
    } else {
      return null;
    }
  };

  const renderDescription = (description) => {
    if (description) {
      return (
        <Typography
          variant="body2"
          color="textSecondary"
          component="p"
        >{`Description: ${description}`}</Typography>
      );
    } else {
      return null;
    }
  };

  const renderSubHeader = (authors) => {
    if (authors) {
      return `By: ${authors.toString().split(",").join(", ")}`;
    } else {
      return "Unknown Author";
    }
  };

  const renderDownloadDialogue = () => {
    if (downloadDialogueOpen) {
      return (
        <DownloadDialogue
          title={props.title}
          authors={props.authors}
          bookId={props.id}
          closeDownloadLinksDialogue={closeDownloadLinksDialogue}
        />
      );
    } else {
      return null;
    }
  };

  return (
    <Grid container spacing={2} className={classes.grid}>
      <Grid item xs={3}>
        <Paper
          variant="outlined"
          className={classes.paper}
          style={{ backgroundImage: `url(${props.cover})` }}
        ></Paper>
      </Grid>
      <Grid item xs={9}>
        <Card className={classes.root} variant="outlined">
          <div className={classes.details}>
            <CardHeader
              title={props.title}
              subheader={renderSubHeader(props.authors)}
            />
            <CardContent className={classes.content}>
              {renderPublisher(props.publisher)}
              {renderDescription(props.description)}
            </CardContent>
            <CardActions className={classes.actions}>
              <Button color="primary" onClick={openDownloadLinksDialogue}>
                Download
              </Button>
              {renderDownloadDialogue()}
            </CardActions>
          </div>
        </Card>
      </Grid>
    </Grid>
  );
}
